export const orderStatus = {
  accepted: {
    index: 2,
    label: 'Accepted',
  },
  in_delivery: {
    index: 3,
    label: 'In delivery',
  },
  delivered: {
    index: 4,
    label: 'Delivered',
  },
  canceled: {
    index: 5,
    label: 'Cancelled',
  },
  ready: {
    index: 7,
    label: 'Ready',
  },
};
